import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import { LanguageProvider } from '../core/language-provider';
import { Helmet } from 'react-helmet';


export default function NotFoundNotLogged() {

    const navigate = useNavigate();

    useEffect(() => {
        navigate('/')
    }, []);

    return (
        <>
            <Helmet>
                <title>Page 404</title>
            </Helmet>
            <Container fluid='sm' className='mt-5 mb-5 text-secondary text-center'>
                <h1>Ops!</h1>
                <p className='lead'>Pagina non trovata.</p>
                <Link to="/">
                    <Button variant='primary' size={'lg'}>{LanguageProvider.get('defaults.back_to_home')}</Button>
                </Link>
            </Container>
        </>
    );
};